import { createContext, useContext, useMemo } from "react";
import { useLocalStorage } from "./useLocalStorage";
import { ChildrenContent } from "src/shared/interface/props/childrenContent";
import { Auth } from "src/auth/auth";
import { SignInInput } from "aws-amplify/auth";
import { useNavigate } from "react-router-dom";
const AuthContext = createContext({} as any);

export const AuthProvider = ({ children }: ChildrenContent) => {
  const navigate = useNavigate();
  const [user, setUser] = useLocalStorage("user", null);

  // call this function when you want to authenticate the user
  const login = async (data: SignInInput) => {
    const successLogin = await Auth.handleSignIn(data);
    if (successLogin) {
        const dataUser = await Auth.currentAuthenticatedUser();
        setUser(JSON.stringify(dataUser));
        navigate("/", {replace: true})
    };
  };

  // call this function to sign out logged in user
  const logout = () => {
    setUser(null);
    Auth.handleSignOut();
    localStorage.clear();
    navigate("/login", {replace: true})
  };

  const value = useMemo(
    () => ({
      user,
      login,
      logout
    }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [user]
  );
  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

export const useAuth = () => {
  return useContext(AuthContext);
};